import './style.scss';

export function image_text_block() {
    const block = document.querySelector('.image_text_block');
    if (!block) return;
}

